// extracted by mini-css-extract-plugin
module.exports =  {"root":"a867bdd7c0--root--oJutx","wrapper":"a867bdd7c0--wrapper--PeLHZ","table":"a867bdd7c0--table--j9cKt","row":"a867bdd7c0--row--ICcNe","cell":"a867bdd7c0--cell--TXUbT"};